import React from 'react';
import type { HTMLAttributes } from 'react';
import './ui.css';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  glass?: boolean;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className = '', glass = true, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`${glass ? 'glass-card' : 'card'} ${className}`}
        {...props}
      >
        {children}
      </div>
    );
  }
);
Card.displayName = 'Card';
